import { render, staticRenderFns } from "./GradingHistory.vue?vue&type=template&id=b5fd5876&scoped=true"
import script from "./GradingHistory.vue?vue&type=script&lang=js"
export * from "./GradingHistory.vue?vue&type=script&lang=js"
import style0 from "./GradingHistory.vue?vue&type=style&index=0&id=b5fd5876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fd5876",
  null
  
)

export default component.exports